import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import ListingContent from '@spotahome/marketplace-common/src/components/ListingContent';
import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';

import { ListingSection } from './ListingSection';

const ListingFlatmates = props => (
  <ListingSection>
    <ListingTitle role="secondary">
      {trans('listing.flatmates.title')}
    </ListingTitle>
    <ListingContent content={props.flatmatesDescription} />
  </ListingSection>
);

ListingFlatmates.propTypes = {
  flatmatesDescription: PropTypes.string.isRequired
};

export default ListingFlatmates;
